import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Music2 } from "lucide-react";
import api from "@/lib/upr-api";

export default function Playlists() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/playlists")
      .then(({ data }) => setItems(Array.isArray(data) ? data : []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="px-6 md:px-12 lg:px-16 py-12 md:py-20" data-testid="playlists-page">
      <div className="upr-eyebrow mb-6"><span className="upr-divider" />Playlists</div>
      <h1 className="font-heading font-black tracking-tighter leading-[0.9] text-4xl sm:text-5xl lg:text-6xl mb-4" style={{ letterSpacing: "-0.035em" }}>
        Curated listening.
      </h1>
      <p className="max-w-xl mb-12" style={{ color: "var(--upr-muted)" }}>
        Themed selections pulled straight from our catalogue. Hit play — the whole thing streams in order.
      </p>

      {loading ? (
        <div className="text-sm" style={{ color: "var(--upr-muted)" }}>Loading…</div>
      ) : items.length === 0 ? (
        <div className="text-sm" style={{ color: "var(--upr-muted)" }} data-testid="playlists-empty">
          No playlists yet.
        </div>
      ) : (
        <ul className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8" data-testid="playlists-grid">
          {items.map((p) => (
            <li key={p.id} data-testid={`playlist-card-${p.slug}`}>
              <Link
                to={`/playlists/${p.slug}`}
                className="block group"
              >
                <div
                  className="aspect-square overflow-hidden mb-3 relative"
                  style={{ background: "var(--upr-surface)", border: "1px solid var(--upr-border)" }}
                >
                  {p.cover_url ? (
                    <img
                      src={p.cover_url}
                      alt={p.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
                      loading="lazy"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center" style={{ color: "var(--upr-muted)" }}>
                      <Music2 size={40} />
                    </div>
                  )}
                </div>
                <div className="font-heading font-extrabold text-lg leading-tight group-hover:text-[color:var(--upr-primary)] transition-colors">
                  {p.title}
                </div>
                <div className="text-xs mt-1" style={{ color: "var(--upr-muted)" }}>
                  {p.track_count} {p.track_count === 1 ? "track" : "tracks"}
                  {p.description ? ` · ${p.description}` : ""}
                </div>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
